// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const WarrantyBeginMeasurement = t.struct({
    reading: t.String,
    unit: t.String
}, {
    name: 'WarrantyBeginMeasurement',
    strict: true
});

export const getDefaultState = () => new WarrantyBeginMeasurement({
    reading: '',
    unit: ''
});

export default WarrantyBeginMeasurement;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/warranty-begin-measurement.js